module.exports = __webpack_public_path__ + "img/5.2589d802.jpg";